<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="row">
          <div class="col">
            <div class="input-group mb-3">
              <span class="input-group-text">Partner:<span class="custom-astrisk">*</span></span>
              <select id="channel" v-model="partner" class="form-control">
                <option v-for="item of partners" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="input-group mb-3">
              <span class="input-group-text">App:<span class="custom-astrisk">*</span></span>
              <select v-if="!isAdd" id="channel" v-model="selectedApp" class="form-control">
                <option v-for="item of apps" :key="item.app" :value="item.app">
                  {{ item.appName }}
                </option>
              </select>
              <input v-if="isAdd" v-model="newAppName" type="text" class="form-control" placeholder="App Name" />
              <input v-if="isAdd" v-model="newAppNumber" type="text" class="form-control" placeholder="App Number" />
              <button v-if="isAdd" class="btn btn-warning custom-focus" type="button" title="cancel" tabindex="-1" @click="cancel">
                <i class="fas fa-ban"></i>
              </button>
              <button v-if="!isAdd" class="btn btn-success custom-focus" type="button" title="add App" tabindex="-1" @click="addApp">
                <i class="fas fa-plus"></i>
              </button>
              <button v-if="isAdd" class="btn btn-success custom-focus" type="button" title="save App" tabindex="-1" @click="saveNewApp">
                <i class="fas fa-check"></i>
              </button>
              <span v-if="!isAdd" class="custom-app-number">{{ selectedAppNumber }}</span>
            </div>
          </div>
          <div class="col">
            <div class="form-check form-switch">
              <input id="isBms" v-model="isBMS" class="form-check-input" type="checkbox" @change="changed" />
              <label class="form-check-label" for="isBms">Is BMS?</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <z-input v-model="apiUrl" name="apiUrl" label="API Url" :required="true" @keyup="changed" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <z-input v-model="portalUrl" name="portalUrl" label="Portal Url" :required="true" @keyup="changed" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <z-input v-model="reportUrl" name="reportUrl" label="Report Url" @keyup="changed" />
          </div>
        </div>
        <div class="row">
          <div class="col"><span class="custom-astrisk">*</span><span class="custom-required">required</span></div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" :disabled="isSaving" @click="close()">Cancel</button>
            <button v-if="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { appsStore } from '@/stores/apps'
import { locationStore } from '@/stores/location'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
export default {
  name: 'DialogApp',
  components: {
    ZDialog,
    ZInput,
    ZMessage
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      message: null,
      isSaving: false,
      isAdd: false,
      newAppName: null,
      newAppNumber: null
    }
  },
  emits: ['closing', 'saved'],
  computed: {
    ...mapState(appsStore, ['apps', 'firmApp']),
    ...mapState(locationStore, ['partners']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = 'Add Location/App'
      if (this.modelValue) {
        if (this.modelValue.isAdd) {
          _title = 'Add Location/App'
        } else {
          _title = 'Edit Location/App'
        }
      }
      return _title
    },
    partner: {
      get() {
        let _data = null
        if (this.firmApp) {
          _data = this.firmApp.firm
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAppData({ name: 'firm', value: value })
        let found = this.partners.find((item) => item.id === value)
        if (found) {
          this.setAppData({ name: 'firmName', value: found.name })
        }
      }
    },
    selectedApp: {
      get() {
        let _data = null
        if (this.firmApp) {
          _data = this.firmApp.app
        }
        return _data
      },
      set(value) {
        this.isSave = true
        let found = this.apps.find((item) => item.app === value)
        if (found) {
          this.setAppData({ name: 'app', value: found.app })
          this.setAppData({ name: 'appName', value: found.appName })
          this.setAppData({ name: 'appNumber', value: found.appNumber })
        }
      }
    },
    selectedAppNumber() {
      let _data = null
      if (this.firmApp) {
        _data = this.firmApp.appNumber
      }
      return _data
    },
    apiUrl: {
      get() {
        let _data = null
        if (this.firmApp) {
          _data = this.firmApp.apiUrl
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAppData({ name: 'apiUrl', value: value })
      }
    },
    portalUrl: {
      get() {
        let _data = null
        if (this.firmApp) {
          _data = this.firmApp.portalUrl
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAppData({ name: 'portalUrl', value: value })
      }
    },
    reportUrl: {
      get() {
        let _data = null
        if (this.firmApp) {
          _data = this.firmApp.reportUrl
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAppData({ name: 'reportUrl', value: value })
      }
    },
    isBMS: {
      get() {
        let _is = false
        if (this.firmApp) {
          _is = this.firmApp.isBms
        }
        return _is
      },
      set(value) {
        this.isSave = true
        this.setAppData({ name: 'isBms', value: value })
      }
    }
  },
  methods: {
    ...mapActions(appsStore, ['getApps', 'setApp', 'setAppData', 'saveApp', 'saveFirmApp']),
    close() {
      this.isSave = false
      this.$emit('closing')
    },
    changed() {
      this.isSave = true
    },
    cancel() {
      this.newAppName = null
      this.newAppNumber = null
      this.isAdd = false
    },
    addApp() {
      this.newAppName = null
      this.newAppNumber = null
      this.isAdd = true
    },
    async saveNewApp() {
      // save the app
      if (this.newAppName !== null && this.newAppNumber !== null) {
        let data = {
          appName: this.newAppName,
          appNumber: this.newAppNumber
        }
        await this.saveApp(data)
        await this.getApps(null)
        this.cancel()
      } else {
        this.message = 'Please provide a value for App Name and App Number.'
      }
    },
    async save() {
      let what = ''
      let proceed = true
      this.message = null
      if (this.isSave) {
        console.log('validating firmApp', this.firmApp)
        if (this.partner === null) {
          what = 'Partner'
          proceed = false
        }
        if (this.selectedApp === null) {
          what = 'App'
          proceed = false
        }
        if (this.firmApp.apiUrl === null || this.firmApp.apiUrl.trim() === '') {
          what = 'API Url'
          proceed = false
        }
        if (this.firmApp.portalUrl === null || this.firmApp.portalUrl.trim() === '') {
          what = 'Portal Url'
          proceed = false
        }
        if (proceed) {
          await this.saveFirmApp()
          this.$emit('saved')
        } else {
          this.message = `Please provide a value for ${what}.`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-app-number {
  position: absolute;
  bottom: -20px;
  font-size: 0.8em;
  font-style: italic;
  left: 60px;
}
.custom-astrisk {
  color: red;
  position: relative;
  top: -3px;
  left: 2px;
}
.custom-required {
  margin-left: 5px;
  color: red;
  font-size: 0.9em;
}
</style>
